import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SkillsFilterQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters?: Types.InputMaybe<Types.SkillsFilters>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type SkillsFilterQuery = { skills: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string } }> | null } };


export const SkillsFilterDocument = /*#__PURE__*/ gql`
    query skillsFilter($sort: [SortType!], $filters: SkillsFilters, $after: String, $first: Float) {
  skills(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

export function useSkillsFilterQuery(options?: Omit<Urql.UseQueryArgs<SkillsFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<SkillsFilterQuery, SkillsFilterQueryVariables>({ query: SkillsFilterDocument, ...options });
};